module.exports = __webpack_public_path__ + "assets/img/gar14-1.869d8b52.jpg";